import { FC, invalidateQuery } from '../../../Services'

export const deleteDocument = async (environmentId) => {
  const res = await FC.service('mappedDocuments').remove(environmentId)
  invalidateQuery(['mappedDocuments'])
  window.growl.show({ severity: 'success', summary: 'Success', detail: 'Eliminazione effettuata' })
  return res
}
